import React from 'react'

type Props = {
  isVisible: String,
  page: String,
  token: String,
  admintype: String,
}

const StatisticsIframe = ({ isVisible, page, token, admintype }: Props) => (
  <iframe
    title={page}
    frameBorder="0"
    style={{ position: 'absolute', left: '1%', width: '98%', minHeight: '60%', maxHeight: '80%', opacity: isVisible ? 1 : 0, zIndex: isVisible ? 999 : -999 }}
    src={`https://datastudio.google.com/embed/reporting/9fe571f3-1a5a-457a-80b2-1ad72b247736/page/${page}?params=%7B%22ds0%22:%7B%22token%22:%22${token}%22,%20%22admintype%22:%22${admintype}%22%7D%7D`}
  />
)

export default React.memo(StatisticsIframe)
